














































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Surface, Typography, Picture } from '@/components/atoms';
import OfferPreview from '@/components/organisms/OfferFreeCoins/OfferPreview.vue';

import eventBus from '@/utils/eventBus';

@Component({ components: { Surface, Typography, Picture, OfferPreview } })
export default class CoinsLearnModal extends Vue {
  @Prop() readonly coins?: string;
  onClose() {
    eventBus.$emit('closeModal');
  }
}
